export const pointData = [
    { lat: 40.0117548291348, lng: 116.39341473604895, speed: 5.28 },
  { lat: 40.0120620884788, lng: 116.39406863222541, speed: 5.28 },
  { lat: 40.01212559408676, lng: 116.39427616797775, speed: 5.28 },
  { lat: 40.012137893431685, lng: 116.39446969084577, speed: 5.28 },
  { lat: 40.012106646137376, lng: 116.39474474668964, speed: 5.28 },
  { lat: 40.01202592685098, lng: 116.39506777110273, speed: 5.28 },
  { lat: 40.01192843763274, lng: 116.39646802314564, speed: 5.28 },
  { lat: 40.01175175863013, lng: 116.39694906275349, speed: 5.28 },
  { lat: 40.01162585563584, lng: 116.39702437442872, speed: 5.28 },
  { lat: 40.011539601018235, lng: 116.39702835838443, speed: 5.34 },
  { lat: 40.01145575471953, lng: 116.39702557293901, speed: 5.34 },
  { lat: 40.01141101579246, lng: 116.39700850927488, speed: 5.34 },
  { lat: 40.01133453801623, lng: 116.39698351250934, speed: 5.34 },
  { lat: 40.011286490754806, lng: 116.39691796511102, speed: 5.34 },
  { lat: 40.011199911026694, lng: 116.39670779169182, speed: 5.34 },
  { lat: 40.01116040760361, lng: 116.39662308413745, speed: 5.34 },
  { lat: 40.01111343594853, lng: 116.39655983248281, speed: 5.34 },
  { lat: 40.01106369215807, lng: 116.39652156321256, speed: 5.34 },
  { lat: 40.01096864731035, lng: 116.39649466986032, speed: 5.34 },
  { lat: 40.01092348672256, lng: 116.39650331664734, speed: 5.02 },
  { lat: 40.010434871293356, lng: 116.39676022019239, speed: 5.02 },
  { lat: 40.01038908352785, lng: 116.39679342225179, speed: 5.02 },
  { lat: 40.01036050798428, lng: 116.39685010501603, speed: 5.02 },
  { lat: 40.010354722407584, lng: 116.3969287888383, speed: 5.02 },
  { lat: 40.01036816424004, lng: 116.39699229161556, speed: 5.02 },
  { lat: 40.010435045938706, lng: 116.39714521472638, speed: 5.02 },
  { lat: 40.01082517391424, lng: 116.39820460590408, speed: 5.02 },
  { lat: 40.01086926080971, lng: 116.3983804730085, speed: 5.02 },
  { lat: 40.01086921175121, lng: 116.39857583745061, speed: 5.02 },
  { lat: 40.01089058567102, lng: 116.3986993516819, speed: 5.12 },
  { lat: 40.01105873352734, lng: 116.398903336089, speed: 5.12 },
  { lat: 40.0117048310656, lng: 116.39940749128573, speed: 5.12 },
  { lat: 40.011817646401546, lng: 116.3995127287103, speed: 5.12 },
  { lat: 40.01207565254974, lng: 116.39963893563231, speed: 5.12 },
  { lat: 40.012336234138495, lng: 116.39972895650226, speed: 5.12 },
  { lat: 40.012695265449956, lng: 116.39976079596943, speed: 5.12 },
  { lat: 40.012823331404256, lng: 116.39975127138678, speed: 5.12 },
  { lat: 40.014219851848495, lng: 116.39973992489263, speed: 5.12 },
  { lat: 40.014384975221255, lng: 116.3997562349249, speed: 5.12 },
  { lat: 40.01546296892558, lng: 116.39980241795297, speed: 5.13 },
  { lat: 40.01590124041839, lng: 116.39983292570605, speed: 5.13 },
  { lat: 40.01607062255886, lng: 116.3997612995297, speed: 5.13 },
  { lat: 40.016147852062744, lng: 116.39970370301944, speed: 5.13 },
  { lat: 40.01651717450411, lng: 116.39926590503478, speed: 5.13 },
  { lat: 40.01670726449425, lng: 116.39907723100691, speed: 5.13 },
  { lat: 40.016810623357536, lng: 116.3989944065313, speed: 5.13 },
  { lat: 40.01704968252044, lng: 116.3988465704333, speed: 5.13 },
  { lat: 40.017220854415385, lng: 116.39879338176638, speed: 5.13 },
  { lat: 40.01739781473131, lng: 116.39878869263384, speed: 5.13 },
  { lat: 40.01753062487387, lng: 116.3988243257802, speed: 4.51 },
  { lat: 40.01778123359699, lng: 116.39897309990852, speed: 4.51 },
  { lat: 40.01788853744789, lng: 116.39909820616651, speed: 4.51 },
  { lat: 40.01813193134938, lng: 116.39946535178092, speed: 4.51 },
  { lat: 40.018315327063775, lng: 116.39978948986754, speed: 4.51 },
  { lat: 40.0185210788888, lng: 116.40004083949202, speed: 4.51 },
  { lat: 40.01862482261567, lng: 116.40011729510957, speed: 4.51 },
  { lat: 40.01884130824557, lng: 116.40023225482969, speed: 4.51 },
  { lat: 40.01900223089695, lng: 116.4002560453863, speed: 4.51 },
  { lat: 40.019168496443335, lng: 116.40024253122397, speed: 4.51 },
  { lat: 40.01941823727352, lng: 116.40014813882294, speed: 5.46 },
  { lat: 40.01955582879214, lng: 116.40006597232173, speed: 5.46 },
  { lat: 40.019625794613496, lng: 116.40003277322512, speed: 5.46 },
  { lat: 40.01973494711923, lng: 116.39992947439282, speed: 5.46 },
  { lat: 40.02003457258235, lng: 116.3995840650133, speed: 5.46 },
  { lat: 40.02012681092414, lng: 116.39951377284751, speed: 5.46 },
  { lat: 40.020240189422374, lng: 116.3994725197183, speed: 5.46 },
  { lat: 40.0207023603236, lng: 116.39944385731519, speed: 5.46 },
  { lat: 40.02075971709272, lng: 116.3990343313751, speed: 5.46 },
  { lat: 40.0210070942486, lng: 116.39833903113333, speed: 5.46 },
  { lat: 40.02107222194391, lng: 116.3980912827493, speed: 5.09 },
  { lat: 40.021459215267924, lng: 116.39703698653, speed: 5.09 },
  { lat: 40.02171541981845, lng: 116.39629073287347, speed: 5.09 },
  { lat: 40.02176033952772, lng: 116.39612248144692, speed: 5.09 },
  { lat: 40.02177240422605, lng: 116.39600839278842, speed: 5.09 },
  { lat: 40.02176568294195, lng: 116.39583289602706, speed: 5.09 },
  { lat: 40.02169624845353, lng: 116.3955147900383, speed: 5.09 },
  { lat: 40.021679187121094, lng: 116.39528962771942, speed: 5.09 },
  { lat: 40.02173659840765, lng: 116.39464098614542, speed: 5.09 },
  { lat: 40.02173608705779, lng: 116.39436350966696, speed: 5.09 },
  { lat: 40.02171667908074, lng: 116.3941582437958, speed: 5.05 },
  { lat: 40.02167744751307, lng: 116.39389140478511, speed: 5.05 },
  { lat: 40.021399744559034, lng: 116.39274655124427, speed: 5.05 },
  { lat: 40.021404538563104, lng: 116.39255736643156, speed: 5.05 },
  { lat: 40.02137436892016, lng: 116.39193287395665, speed: 5.05 },
  { lat: 40.02137898050156, lng: 116.39151162261976, speed: 5.05 },
  { lat: 40.02135519400907, lng: 116.39116088703008, speed: 5.05 },
  { lat: 40.02137912746466, lng: 116.39077853832805, speed: 5.05 },
  { lat: 40.02149345166241, lng: 116.38987130562305, speed: 5.05 },
  { lat: 40.02166277008334, lng: 116.3891133772753, speed: 5.05 },
  { lat: 40.0216995668407, lng: 116.38882302992442, speed: 5.15 },
  { lat: 40.021681727047586, lng: 116.38861179148807, speed: 5.15 },
  { lat: 40.02152248615635, lng: 116.38774109212864, speed: 5.15 },
  { lat: 40.0213921439682, lng: 116.38745117664939, speed: 5.15 },
  { lat: 40.02123145185149, lng: 116.38716827874737, speed: 5.15 },
  { lat: 40.02092044344663, lng: 116.38679497138503, speed: 5.15 },
  { lat: 40.020891135369794, lng: 116.38677277623628, speed: 5.15 },
  { lat: 40.02028603423594, lng: 116.38606765345298, speed: 5.15 },
  { lat: 40.0198617793528, lng: 116.38508154730812, speed: 5.15 },
  { lat: 40.019680540067355, lng: 116.38388233477303, speed: 5.15 },
  { lat: 40.01952046118871, lng: 116.3832977387624, speed: 5.05 },
  { lat: 40.01924186224846, lng: 116.38263027970129, speed: 5.05 },
  { lat: 40.01914726464586, lng: 116.38245812882292, speed: 5.05 },
  { lat: 40.01894223267785, lng: 116.38218707704368, speed: 5.05 },
  { lat: 40.01879139918298, lng: 116.38203694175695, speed: 5.05 },
  { lat: 40.018651920883435, lng: 116.38181075359091, speed: 5.05 },
  { lat: 40.01847319163035, lng: 116.38142942845275, speed: 5.05 },
  { lat: 40.01828931219562, lng: 116.38118829755808, speed: 5.05 },
  { lat: 40.0180601171968, lng: 116.38100125118933, speed: 5.05 },
  { lat: 40.01794585528901, lng: 116.38093509419627, speed: 5.05 },
  { lat: 40.0176609625524, lng: 116.38085471399313, speed: 5.46 },
  { lat: 40.01736337023258, lng: 116.38082206686022, speed: 5.46 },
  { lat: 40.017204497705734, lng: 116.38082447131978, speed: 5.46 },
  { lat: 40.0169331320741, lng: 116.38089064701808, speed: 5.46 },
  { lat: 40.01678218238459, lng: 116.38095016240231, speed: 5.46 },
  { lat: 40.01658695386989, lng: 116.3810908837936, speed: 5.46 },
  { lat: 40.01629254190362, lng: 116.38137514729988, speed: 5.46 },
  { lat: 40.01585210668406, lng: 116.38202332996468, speed: 5.46 },
  { lat: 40.01536057607682, lng: 116.38317040921515, speed: 5.46 },
  { lat: 40.015275722290205, lng: 116.3833619571393, speed: 5.46 },
  { lat: 40.01511484109611, lng: 116.3835313861075, speed: 5.58 },
  { lat: 40.01479727241819, lng: 116.38398719175825, speed: 5.58 },
  { lat: 40.01467861304151, lng: 116.38454193643474, speed: 5.58 },
  { lat: 40.014540225997486, lng: 116.38506669712035, speed: 5.58 },
  { lat: 40.01438381183924, lng: 116.38548144796403, speed: 5.58 },
  { lat: 40.01413835513588, lng: 116.38591755111986, speed: 5.58 },
  { lat: 40.01386179660761, lng: 116.38621318238154, speed: 5.58 },
  { lat: 40.0134417096248, lng: 116.38646622345004, speed: 5.58 },
  { lat: 40.01319395279727, lng: 116.38654692320529, speed: 5.58 },
  { lat: 40.013025729810465, lng: 116.38661485306432, speed: 5.58 },
  { lat: 40.01286384177789, lng: 116.38670219042137, speed: 5.45 },
  { lat: 40.01273794884273, lng: 116.38680940020959, speed: 5.45 },
  { lat: 40.01205241630339, lng: 116.38764054405476, speed: 5.45 },
  { lat: 40.012012708517204, lng: 116.38799562902909, speed: 5.45 },
  { lat: 40.01200740698218, lng: 116.3884668726007, speed: 5.45 },
  { lat: 40.01205081487235, lng: 116.3891357542683, speed: 5.45 },
  { lat: 40.01214634484927, lng: 116.38985130991023, speed: 5.45 },
  { lat: 40.012129040905016, lng: 116.39039545576566, speed: 5.45 },
  { lat: 40.01198955926475, lng: 116.39095842130325, speed: 5.45 },
  { lat: 40.01187029705991, lng: 116.3912239257852, speed: 5.45 },
  { lat: 40.01178717766782, lng: 116.3914374715223, speed: 5.15 },
]

export const cityList = [
	{
		autoRotate: true,
		duration: 10,
		endCity: {name: "澳门", latitude: 22.186927, longitude: 113.543076},
		headImg: "",
		imgList: [],
		imgShowType: "普通模式",
		isTop: false,
		lineColor: "#56C5B6",
		mediaType: "photo",
		path:[
			{latitude: 31.230861, longitude: 121.473373},
			{latitude: 31.150615999999978, longitude: 121.29091199999999},
			{latitude: 30.67515199999998, longitude: 120.79120000000006},
			{latitude: 30.170340999999983, longitude: 120.34534900000001},
			{latitude: 29.644490999999974, longitude: 120.16800299999994},
			{latitude: 29.233399999999964, longitude: 119.86538},
			{latitude: 29.044952999999975, longitude: 119.11588899999997},
			{latitude: 28.80086299999997, longitude: 118.34373099999995},
			{latitude: 28.39492999999997, longitude: 117.84686299999986},
			{latitude: 28.344424999999966, longitude: 117.11039599999985},
		    {latitude: 28.004725999999977, longitude: 116.83948199999988},
			{latitude: 27.68566699999997, longitude: 116.73909499999992},
			{latitude: 27.324427999999966, longitude: 116.60967099999996},
			{latitude: 26.96522499999996, longitude: 116.40858199999998},
			{latitude: 26.580576999999966, longitude: 116.34685200000001},
			{latitude: 26.255424999999978, longitude: 116.14001300000004},
			{latitude: 25.919206999999986, longitude: 115.97933900000002},
			{latitude: 25.57394000000001, longitude: 115.81082100000009},
			{latitude: 25.22148599999999, longitude: 115.75947000000012},
			{latitude: 24.88459599999998, longitude: 115.74690200000013},
			 {latitude: 24.661717999999965, longitude: 115.46457200000012},
			{latitude: 24.27255399999995, longitude: 115.40634500000012},
			{latitude: 23.899786999999943, longitude: 115.24191700000019},
			{latitude: 23.566796999999955, longitude: 115.1239160000002},
			{latitude: 23.306444999999957, longitude: 114.74418800000015},
			{latitude: 23.02281299999995, longitude: 114.46308000000013},
			{latitude: 22.997565999999942, longitude: 114.11250500000014},
			{latitude: 22.915567999999965, longitude: 113.78101500000008},
			{latitude: 22.735650999999972, longitude: 113.47692900000011},
			{latitude: 22.35001599999997, longitude: 113.4928710000001},
			{latitude: 22.189974999999986, longitude: 113.54005200000003},
			{latitude: 22.186954999999983, longitude: 113.54287300000006},
		],
		routeDesign: true,
		startCity: {name: "上海", latitude: 31.230525, longitude: 121.473667},
		title: "",
		vehicle: "car2",
		vehicleUrl: "https://mp-af2ae419-8d72-4586-b078-94a30e971439.cdn.bspapp.com/static/car2.png",
		videoImg: "",
		videoUrl: "",	
	},
	{
		autoRotate: true,
		duration: 8,
		endCity: {name: "百色", latitude: 23.90307, longitude: 106.61869},
		headImg: "",
		imgList: [],
		imgShowType: "普通模式",
		isTop: false,
		lineColor: "#56C5B6",
		mediaType: "photo",
		path: [
			{latitude: 22.186955, longitude: 113.542873},
			{latitude: 22.208601999999996, longitude: 113.52516800000001},
			{latitude: 22.200566000000006, longitude: 113.36397900000001},
			{latitude: 22.466818000000018, longitude: 113.17317800000002},
			{latitude: 22.584147000000023, longitude: 112.940886},
			{latitude: 22.549333000000033, longitude: 112.80632400000002},
			{latitude: 22.619224000000024, longitude: 112.54410700000008},
			{latitude: 22.720339000000024, longitude: 112.34809200000001},
			{latitude: 22.729001000000025, longitude: 112.148825},
			{latitude: 22.740864000000023, longitude: 111.91383399999998},
			{latitude: 22.78471900000002, longitude: 111.64534},
			{latitude: 22.823083000000015, longitude: 111.39158900000004},
			{latitude: 22.894597000000008, longitude: 111.190804},
			{latitude: 22.902327000000014, longitude: 110.97224500000002},
			{latitude: 22.876912000000022, longitude: 110.78741000000002},
			{latitude: 22.884170000000037, longitude: 110.61468400000007},
			{latitude: 22.807077000000067, longitude: 110.36364800000007},
			{latitude: 22.758843000000073, longitude: 110.12924500000011},
			{latitude: 22.817493000000063, longitude: 109.88625200000016},
			{latitude: 22.89456300000006, longitude: 109.5853250000001},
			{latitude: 22.887026000000066, longitude: 109.1707770000001},
			{latitude: 22.853171000000064, longitude: 108.84247600000008},
			{latitude: 22.927957000000074, longitude: 108.51743600000007},
			{latitude: 22.865333000000074, longitude: 108.23690200000009},
			{latitude: 22.93190200000008, longitude: 107.9902930000001},
			{latitude: 23.197252000000073, longitude: 107.69022500000007},
			{latitude: 23.453949000000073, longitude: 107.38796200000003},
			{latitude: 23.590220000000077, longitude: 107.06814500000004},
			{latitude: 23.72467200000008, longitude: 106.84427800000007},
			{latitude: 23.83721900000008, longitude: 106.63599300000004},
			{latitude: 23.90236700000008, longitude: 106.618224},
			{latitude: 23.90320400000008, longitude: 106.61848299999998},
		],
		routeDesign: true,
		startCity: {name: "澳门", latitude: 22.186927, longitude: 113.543076},
		title: "",
		vehicle: "car4",
		vehicleUrl: "https://mp-af2ae419-8d72-4586-b078-94a30e971439.cdn.bspapp.com/static/car4.png",
		videoImg: "",
		videoUrl: "",
	}
]


export const  pointDatas = [
	[
		{ lat: 40.0117548291348, lng: 116.39341473604895, speed: 5.28 },
		{ lat: 40.0120620884788, lng: 116.39406863222541, speed: 5.28 },
		{ lat: 40.01212559408676, lng: 116.39427616797775, speed: 5.28 },
		{ lat: 40.012137893431685, lng: 116.39446969084577, speed: 5.28 },
		{ lat: 40.012106646137376, lng: 116.39474474668964, speed: 5.28 },
		{ lat: 40.01202592685098, lng: 116.39506777110273, speed: 5.28 },
		{ lat: 40.01192843763274, lng: 116.39646802314564, speed: 5.28 },
		{ lat: 40.01175175863013, lng: 116.39694906275349, speed: 5.28 },
		{ lat: 40.01162585563584, lng: 116.39702437442872, speed: 5.28 },
		{ lat: 40.011539601018235, lng: 116.39702835838443, speed: 5.34 },
		{ lat: 40.01145575471953, lng: 116.39702557293901, speed: 5.34 },
		{ lat: 40.01141101579246, lng: 116.39700850927488, speed: 5.34 },
		{ lat: 40.01133453801623, lng: 116.39698351250934, speed: 5.34 },
		{ lat: 40.011286490754806, lng: 116.39691796511102, speed: 5.34 },
		{ lat: 40.011199911026694, lng: 116.39670779169182, speed: 5.34 },
		{ lat: 40.01116040760361, lng: 116.39662308413745, speed: 5.34 },
		{ lat: 40.01111343594853, lng: 116.39655983248281, speed: 5.34 },
		{ lat: 40.01106369215807, lng: 116.39652156321256, speed: 5.34 },
		{ lat: 40.01096864731035, lng: 116.39649466986032, speed: 5.34 },
		{ lat: 40.01092348672256, lng: 116.39650331664734, speed: 5.02 },
		{ lat: 40.010434871293356, lng: 116.39676022019239, speed: 5.02 },
	],
	[
		{ lat: 40.01038908352785, lng: 116.39679342225179, speed: 5.02 },
		{ lat: 40.01036050798428, lng: 116.39685010501603, speed: 5.02 },
		{ lat: 40.010354722407584, lng: 116.3969287888383, speed: 5.02 },
		{ lat: 40.01036816424004, lng: 116.39699229161556, speed: 5.02 },
		{ lat: 40.010435045938706, lng: 116.39714521472638, speed: 5.02 },
		{ lat: 40.01082517391424, lng: 116.39820460590408, speed: 5.02 },
		{ lat: 40.01086926080971, lng: 116.3983804730085, speed: 5.02 },
		{ lat: 40.01086921175121, lng: 116.39857583745061, speed: 5.02 },
		{ lat: 40.01089058567102, lng: 116.3986993516819, speed: 5.12 },
		{ lat: 40.01105873352734, lng: 116.398903336089, speed: 5.12 },
		{ lat: 40.0117048310656, lng: 116.39940749128573, speed: 5.12 },
		{ lat: 40.011817646401546, lng: 116.3995127287103, speed: 5.12 },
		{ lat: 40.01207565254974, lng: 116.39963893563231, speed: 5.12 },
		{ lat: 40.012336234138495, lng: 116.39972895650226, speed: 5.12 },
		{ lat: 40.012695265449956, lng: 116.39976079596943, speed: 5.12 },
		{ lat: 40.012823331404256, lng: 116.39975127138678, speed: 5.12 },
		{ lat: 40.014219851848495, lng: 116.39973992489263, speed: 5.12 },
		{ lat: 40.014384975221255, lng: 116.3997562349249, speed: 5.12 },
		{ lat: 40.01546296892558, lng: 116.39980241795297, speed: 5.13 },
		{ lat: 40.01590124041839, lng: 116.39983292570605, speed: 5.13 },
		{ lat: 40.01607062255886, lng: 116.3997612995297, speed: 5.13 },
		{ lat: 40.016147852062744, lng: 116.39970370301944, speed: 5.13 },
		{ lat: 40.01651717450411, lng: 116.39926590503478, speed: 5.13 },
		{ lat: 40.01670726449425, lng: 116.39907723100691, speed: 5.13 },
		{ lat: 40.016810623357536, lng: 116.3989944065313, speed: 5.13 },
		{ lat: 40.01704968252044, lng: 116.3988465704333, speed: 5.13 },
		{ lat: 40.017220854415385, lng: 116.39879338176638, speed: 5.13 },
		{ lat: 40.01739781473131, lng: 116.39878869263384, speed: 5.13 },
		{ lat: 40.01753062487387, lng: 116.3988243257802, speed: 4.51 },
		{ lat: 40.01778123359699, lng: 116.39897309990852, speed: 4.51 },
		{ lat: 40.01788853744789, lng: 116.39909820616651, speed: 4.51 },
		{ lat: 40.01813193134938, lng: 116.39946535178092, speed: 4.51 },
		{ lat: 40.018315327063775, lng: 116.39978948986754, speed: 4.51 },
		{ lat: 40.0185210788888, lng: 116.40004083949202, speed: 4.51 },
	],
	[
		{ lat: 40.01862482261567, lng: 116.40011729510957, speed: 4.51 },
		{ lat: 40.01884130824557, lng: 116.40023225482969, speed: 4.51 },
		{ lat: 40.01900223089695, lng: 116.4002560453863, speed: 4.51 },
		{ lat: 40.019168496443335, lng: 116.40024253122397, speed: 4.51 },
		{ lat: 40.01941823727352, lng: 116.40014813882294, speed: 5.46 },
		{ lat: 40.01955582879214, lng: 116.40006597232173, speed: 5.46 },
		{ lat: 40.019625794613496, lng: 116.40003277322512, speed: 5.46 },
		{ lat: 40.01973494711923, lng: 116.39992947439282, speed: 5.46 },
		{ lat: 40.02003457258235, lng: 116.3995840650133, speed: 5.46 },
		{ lat: 40.02012681092414, lng: 116.39951377284751, speed: 5.46 },
		{ lat: 40.020240189422374, lng: 116.3994725197183, speed: 5.46 },
		{ lat: 40.0207023603236, lng: 116.39944385731519, speed: 5.46 },
		{ lat: 40.02075971709272, lng: 116.3990343313751, speed: 5.46 },
		{ lat: 40.0210070942486, lng: 116.39833903113333, speed: 5.46 },
		{ lat: 40.02107222194391, lng: 116.3980912827493, speed: 5.09 },
		{ lat: 40.021459215267924, lng: 116.39703698653, speed: 5.09 },
		{ lat: 40.02171541981845, lng: 116.39629073287347, speed: 5.09 },
		{ lat: 40.02176033952772, lng: 116.39612248144692, speed: 5.09 },
		{ lat: 40.02177240422605, lng: 116.39600839278842, speed: 5.09 },
		{ lat: 40.02176568294195, lng: 116.39583289602706, speed: 5.09 },
		{ lat: 40.02169624845353, lng: 116.3955147900383, speed: 5.09 },
		{ lat: 40.021679187121094, lng: 116.39528962771942, speed: 5.09 },
		{ lat: 40.02173659840765, lng: 116.39464098614542, speed: 5.09 },
		{ lat: 40.02173608705779, lng: 116.39436350966696, speed: 5.09 },
		{ lat: 40.02171667908074, lng: 116.3941582437958, speed: 5.05 },
		{ lat: 40.02167744751307, lng: 116.39389140478511, speed: 5.05 },
		{ lat: 40.021399744559034, lng: 116.39274655124427, speed: 5.05 },
		{ lat: 40.021404538563104, lng: 116.39255736643156, speed: 5.05 },
		{ lat: 40.02137436892016, lng: 116.39193287395665, speed: 5.05 },
		{ lat: 40.02137898050156, lng: 116.39151162261976, speed: 5.05 },
		{ lat: 40.02135519400907, lng: 116.39116088703008, speed: 5.05 },
		{ lat: 40.02137912746466, lng: 116.39077853832805, speed: 5.05 },
		{ lat: 40.02149345166241, lng: 116.38987130562305, speed: 5.05 },
		{ lat: 40.02166277008334, lng: 116.3891133772753, speed: 5.05 },
		{ lat: 40.0216995668407, lng: 116.38882302992442, speed: 5.15 },
		{ lat: 40.021681727047586, lng: 116.38861179148807, speed: 5.15 },
		{ lat: 40.02152248615635, lng: 116.38774109212864, speed: 5.15 },
		{ lat: 40.0213921439682, lng: 116.38745117664939, speed: 5.15 },
		{ lat: 40.02123145185149, lng: 116.38716827874737, speed: 5.15 },
		{ lat: 40.02092044344663, lng: 116.38679497138503, speed: 5.15 },
		{ lat: 40.020891135369794, lng: 116.38677277623628, speed: 5.15 },
		{ lat: 40.02028603423594, lng: 116.38606765345298, speed: 5.15 },
		{ lat: 40.0198617793528, lng: 116.38508154730812, speed: 5.15 },
		{ lat: 40.019680540067355, lng: 116.38388233477303, speed: 5.15 },
		{ lat: 40.01952046118871, lng: 116.3832977387624, speed: 5.05 },
		{ lat: 40.01924186224846, lng: 116.38263027970129, speed: 5.05 },
		{ lat: 40.01914726464586, lng: 116.38245812882292, speed: 5.05 },
		{ lat: 40.01894223267785, lng: 116.38218707704368, speed: 5.05 },
		{ lat: 40.01879139918298, lng: 116.38203694175695, speed: 5.05 },
		{ lat: 40.018651920883435, lng: 116.38181075359091, speed: 5.05 },
		{ lat: 40.01847319163035, lng: 116.38142942845275, speed: 5.05 },
		{ lat: 40.01828931219562, lng: 116.38118829755808, speed: 5.05 },
		{ lat: 40.0180601171968, lng: 116.38100125118933, speed: 5.05 },
		{ lat: 40.01794585528901, lng: 116.38093509419627, speed: 5.05 },
		{ lat: 40.0176609625524, lng: 116.38085471399313, speed: 5.46 },
		{ lat: 40.01736337023258, lng: 116.38082206686022, speed: 5.46 },
	],
	[
		{ lat: 40.017204497705734, lng: 116.38082447131978, speed: 5.46 },
		{ lat: 40.0169331320741, lng: 116.38089064701808, speed: 5.46 },
		{ lat: 40.01678218238459, lng: 116.38095016240231, speed: 5.46 },
		{ lat: 40.01658695386989, lng: 116.3810908837936, speed: 5.46 },
		{ lat: 40.01629254190362, lng: 116.38137514729988, speed: 5.46 },
		{ lat: 40.01585210668406, lng: 116.38202332996468, speed: 5.46 },
		{ lat: 40.01536057607682, lng: 116.38317040921515, speed: 5.46 },
		{ lat: 40.015275722290205, lng: 116.3833619571393, speed: 5.46 },
		{ lat: 40.01511484109611, lng: 116.3835313861075, speed: 5.58 },
		{ lat: 40.01479727241819, lng: 116.38398719175825, speed: 5.58 },
		{ lat: 40.01467861304151, lng: 116.38454193643474, speed: 5.58 },
		{ lat: 40.014540225997486, lng: 116.38506669712035, speed: 5.58 },
		{ lat: 40.01438381183924, lng: 116.38548144796403, speed: 5.58 },
		{ lat: 40.01413835513588, lng: 116.38591755111986, speed: 5.58 },
		{ lat: 40.01386179660761, lng: 116.38621318238154, speed: 5.58 },
		{ lat: 40.0134417096248, lng: 116.38646622345004, speed: 5.58 },
		{ lat: 40.01319395279727, lng: 116.38654692320529, speed: 5.58 },
		{ lat: 40.013025729810465, lng: 116.38661485306432, speed: 5.58 },
		{ lat: 40.01286384177789, lng: 116.38670219042137, speed: 5.45 },
		{ lat: 40.01273794884273, lng: 116.38680940020959, speed: 5.45 },
		{ lat: 40.01205241630339, lng: 116.38764054405476, speed: 5.45 },
		{ lat: 40.012012708517204, lng: 116.38799562902909, speed: 5.45 },
		{ lat: 40.01200740698218, lng: 116.3884668726007, speed: 5.45 },
		{ lat: 40.01205081487235, lng: 116.3891357542683, speed: 5.45 },
		{ lat: 40.01214634484927, lng: 116.38985130991023, speed: 5.45 },
		{ lat: 40.012129040905016, lng: 116.39039545576566, speed: 5.45 },
		{ lat: 40.01198955926475, lng: 116.39095842130325, speed: 5.45 },
		{ lat: 40.01187029705991, lng: 116.3912239257852, speed: 5.45 },
		{ lat: 40.01178717766782, lng: 116.3914374715223, speed: 5.15 },
	]
	
]

// export const  imgList =[
// 	'https://mp-af2ae419-8d72-4586-b078-94a30e971439.cdn.bspapp.com/test/image.png',
// 	'https://mp-af2ae419-8d72-4586-b078-94a30e971439.cdn.bspapp.com/test/image1.png',
// 	'https://mp-af2ae419-8d72-4586-b078-94a30e971439.cdn.bspapp.com/test/image2.png',
// 	'https://mp-af2ae419-8d72-4586-b078-94a30e971439.cdn.bspapp.com/test/image3.png',
// 	'https://mp-af2ae419-8d72-4586-b078-94a30e971439.cdn.bspapp.com/test/image4.png',
// ]

export const imgList= [
	'https://mp-af2ae419-8d72-4586-b078-94a30e971439.cdn.bspapp.com/test/image.png',
	'https://mp-af2ae419-8d72-4586-b078-94a30e971439.cdn.bspapp.com/test/image1.png',
	'https://mp-af2ae419-8d72-4586-b078-94a30e971439.cdn.bspapp.com/test/image2.png',
	'https://mp-af2ae419-8d72-4586-b078-94a30e971439.cdn.bspapp.com/test/image3.png',
	'https://mp-af2ae419-8d72-4586-b078-94a30e971439.cdn.bspapp.com/test/image4.png',
	
]